import React, { useState } from "react";
import initialMemberData from "../data/Member";
import useFiles from "../context/FileContext";
import { IoGridOutline } from "react-icons/io5";
import { FaList, FaRegStar } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import MenuComponent from "../Component/MenuComponent";
import { HiDotsVertical } from "react-icons/hi";
import { toast } from "react-hot-toast";
import { GoPlus } from "react-icons/go";
import ShareView from "../Component/ShareView";
import FileInformation from "../Component/FileInformation";
import MoveModal from "../Component/MoveModel";

const Members = () => {
  const [members, setMembers] = useState(initialMemberData);
  const [menuOpen, setMenuOpen] = useState(false);
  const { files, setFiles, viewType, setViewType, search } = useFiles();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [menuOpenId, setMenuOpenId] = useState(false);
  const [renamingId, setRenamingId] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [infoFile, setInfoFile] = useState(null);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [infoModel, setInfoModel] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showMoveModal, setShowMoveModal] = useState(false);
  const [selectedForMove, setSelectedForMove] = useState(null);
  const [submitted, setSumbitted] = useState(false);
  const [newMember, setNewMember] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    icon: "",
    storage: "10 GB",
  });
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "icon" && files.length > 0) {
      const file = files[0];
      const imageUrl = URL.createObjectURL(file);
      setNewMember((prev) => ({ ...prev, icon: imageUrl }));
    } else {
      setNewMember((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleAddMember = () => {
     setSumbitted(true);
    const { name, phone, email, company, icon, storage } = newMember;
    if(!name || !phone || !email || !company || !icon || !storage) {
       toast.error('Please fill all the fileds')
      return;
     
    }
    setMembers((prev) => [...prev, newMember]);
    setNewMember({
      name: "",
      phone: "",
      email: "",
      company: "",
      icon: "",
      storage: "10 GB",
    });
    setMenuOpen(false);
    setSumbitted(false);
  };

  const handleRenameConfirm = (id) => {
    if (renameValue.trim()) {
      setFiles((prev) =>
        prev.map((f) => (f._id === id ? { ...f, name: renameValue.trim() } : f))
      );
      toast.success("Renamed successfully!");
    }
    setRenamingId(null);
  };

  return (
    <div className="mt-[10%] md:mt-[4%]">
      <div className="mt-10 flex justify-between md:mt-5">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="mb-6 text-icon px-4 py-2  rounded-md hover:border-third border border-gray-300 flex items-center gap-2 hover:bg-third hover:text-primary font-medium"
        >
          <GoPlus fontSize={20} className="text-lg" />
          <span>Add Member</span>
        </button>

        <div className="flex border border-gray-300 justify-end  rounded-md overflow-hidden w-fit h-10">
          <button
            className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
              viewType === "list" ? "bg-four text-black" : "text-secondary "
            }`}
            onClick={() => {
              setViewType("list");
              setIsMenuOpen(false);
            }}
          >
            <FaList />
          </button>

          <button
            className={`w-10 h-10 flex items-center justify-center transition duration-200 ${
              viewType === "grid" ? "bg-four text-black" : "text-secondary "
            }`}
            onClick={() => {
              setViewType("grid");
              setIsMenuOpen(false);
            }}
          >
            <IoGridOutline />
          </button>
        </div>
      </div>

      {viewType === "grid" ? (
        <div className="flex gap-4 flex-wrap">
          {members.map((file) => {
            const fileId = file._id || file.id;
            const isSelected = selectedItems.includes(fileId);
            const handleRenameConfirm = () => {
              if (renameValue.trim()) {
                setFiles((prev) =>
                  prev.map((f) =>
                    f._id === file._id ? { ...f, name: renameValue.trim() } : f
                  )
                );
              }
              setRenamingId(null);
            };

            return (
              <div
                key={fileId}
                className="relative rounded-xl w-[218px] h-[210px] p-2 border border-gray-300 bg-four transition duration-200 flex flex-col"
              >
                <div className="w-full ">
                  <img
                    src={file.icon}
                    alt={file.name}
                    className="w-full h-full object-contain "
                  />
                </div>
               <div className="mt-2">
                 {renamingId === file._id ? (
                  <input
                    autoFocus
                    value={renameValue}
                    onChange={(e) => setRenameValue(e.target.value)}
                    onBlur={() => setRenamingId(null)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleRenameConfirm();
                      else if (e.key === "Escape") setRenamingId(null);
                    }}
                    className="text-sm border outline-none  px-2 py-1 w-full rounded-md"
                  />
                ) : (
                  <div className=" ">
                    <span className=" font-bold text-sm truncate cursor-pointer">
                    {file.name.slice(0, 20)}
                  </span>
                  </div>
                )}
               </div>
                <div>
                  <HiDotsVertical
                    fontSize={20}
                    className=" right-4 top-5 absolute text-white"
                    onClick={() =>
                      setMenuOpenId(menuOpenId === fileId ? null : fileId)
                    }
                  />
                </div>
                <div>
                  {menuOpenId === fileId && (
                    <MenuComponent
                      file={file}
                      setMenuOpenId={setMenuOpenId}
                      renameValue={renameValue}
                      setRenameValue={setRenameValue}
                      setRenamingId={setRenamingId}
                      showShareModal={showShareModal}
                      infoModel={infoModel}
                      setInfoModel={setInfoModel}
                      setShowShareModal={setShowShareModal}
                      showInfoModal={showInfoModal}
                      setShowInfoModal={setShowInfoModal}
                      setInfoFile={setInfoFile}
                    />
                  )}
                  {showShareModal && (
                    <ShareView
                      setIsOpen={setShowShareModal}
                      handleShare={() => {
                        toast.success("File shared successfully!");
                        setShowShareModal(false);
                      }}
                    />
                  )}

                  {showInfoModal && infoFile && (
                    <FileInformation
                      showInfoModal={showInfoModal}
                      infoFile={infoFile}
                      onClose={() => setShowInfoModal(false)}
                    />
                  )}

                  {showMoveModal && selectedForMove && (
                    <MoveModal
                      file={selectedForMove}
                      folders={files.filter((f) => f.isDirectory && !f.trashed)}
                      onClose={() => setShowMoveModal(false)}
                      onMove={(destinationId) => {
                        setFiles((prev) =>
                          prev.map((f) =>
                            f._id === selectedForMove._id
                              ? { ...f, parentId: destinationId }
                              : f
                          )
                        );
                        setShowMoveModal(false);
                        toast.success("Moved successfully");
                      }}
                    />
                  )}
                </div>

                <div>
                 
                  <div className=" flex justify-between mt-1">
                    <span className=" text-xs text-icon font-medium">
                      {file.company}
                    </span>
                    <span className=" text-xs text-icon font-medium">
                      {file.spaceused}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="w-full overflow-x-auto mt-5">
          <table className="min-w-[700px] w-full table-auto  text-sm ">
            <thead className=" text-xs md:text-sm">
              <tr className=" text-secondary font-semibold">
                {[
                  "Icon",
                  "Name",
                  "Email",
                  "Phone",
                  "Company",
                  "Space Used",
                ].map((col, i) => (
                  <th
                    className="p-2 md:p-4 whitespace-nowrap text-secondary "
                    key={i}
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {members.map((member, index) => (
                <tr key={index} className="text-center hover:bg-gray-50">
                  <td className="p-2 md:p-4 text-secondary">
                    <img
                      src={member.icon}
                      alt={member.name}
                      className="w-10 h-10 mx-auto rounded-full object-cover"
                    />
                  </td>
                  <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                    {member.name}
                  </td>
                  <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                    {member.email}
                  </td>
                  <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                    {member.phone}
                  </td>
                  <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                    {member.company}
                  </td>
                  <td className="p-2 md:p-4 text-secondary text-[12px] md:text-sm whitespace-nowrap">
                    {member.spaceused}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {menuOpen && (
     <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50 px-4">
  <div className="bg-white rounded-lg  border">
    
    <h3 className="text-xl font-semibold p-4">New Client</h3>
    <hr />

   
    <div className="p-4 ">
     
      <div>
        <label className="mb-1 font-bold block text-secondary text-sm">
          Name:
        </label>
        <input
          type="text"
          name="name"
          value={newMember.name}
          onChange={handleChange}
          className="w-full bg-gray-100 px-3 py-2 rounded-md outline-none"
        />
        {submitted &&(
          <p className="font-medium text-red-500 text-xs">Name is required</p>
        )}
      </div>

      
      <div>
        <label className="mb-1 font-bold text-sm block text-secondary">
          Phone:
        </label>
        <input
          type="number"
          name="phone"
          value={newMember.phone}
          onChange={handleChange}
          className="w-full bg-gray-100 px-3 py-2 rounded-md outline-none"
        />
         {submitted &&(
          <p className="font-medium text-red-500 text-xs">Phone is required</p>
        )}
      </div>

     
      <div>
        <label className="mb-1 font-bold text-sm block text-secondary">
          E-mail:
        </label>
        <input
          type="email"
          name="email"
          value={newMember.email}
          onChange={handleChange}
          className="w-full bg-gray-100 px-3 py-2 rounded-md outline-none"
        />
         {submitted &&(
          <p className="font-medium text-red-500 text-xs">E-mail is required</p>
        )}
      </div>

     
      <div>
        <label className="mb-1 text-sm block font-bold text-secondary">
          Company:
        </label>
        <input
          type="text"
          name="company"
          value={newMember.company}
          onChange={handleChange}
          className="w-full bg-gray-100 px-3 py-2 rounded-md outline-none"
        />
         {submitted &&(
          <p className="font-medium text-red-500 text-xs">Company is required</p>
        )}
      </div>

     
      <div>
        <label className="mb-1 font-bold text-sm block text-secondary">
          Icon:
        </label>
        <input
          type="file"
          accept="image/*"
          name="icon"
          onChange={handleChange}
          className="w-full bg-gray-100 px-3 py-2 rounded-md outline-none"
        />
         {submitted &&(
          <p className="font-medium text-red-500 text-xs">Icon is required</p>
        )}
      </div>

     
      <div>
        <label className="mb-1 text-sm block font-bold text-secondary">
          Storage Limit:
        </label>
        <select
          name="storage"
          value={newMember.storage}
          onChange={handleChange}
          className="w-full bg-gray-100 px-3 py-2 rounded-md outline-none"
        >
          <option value="10 GB">10 GB</option>
          <option value="20 GB">20 GB</option>
          <option value="50 GB">50 GB</option>
          <option value="100 GB">100 GB</option>
        </select>
        
      </div>
    </div>

    <hr />

    {/* Actions */}
    <div className="flex justify-end gap-4 p-4">
      <button
        onClick={() => setMenuOpen(false)}
        className="text-sm text-primary font-semibold"
      >
        Cancel
      </button>
      <button
        onClick={() => handleAddMember(newMember)}
        className="text-sm px-4 py-2 font-semibold text-white bg-primary rounded-md"
      >
        Add
      </button>
    </div>
  </div>
</div>

      )}
    </div>
  );
};

export default Members;
